// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2lrR4","title":"BackImages_title__pSZ3M","images":"BackImages_images__QFCaT"};